import mapKeys from 'lodash.mapkeys';
import queryString from 'query-string';
import toastr from 'toastr';

export const CasesFiltersList = {
  state: {
    filters: {
      sections: [],
      tags: [],
      group: '0',
      orderBy: 'last_activity_at',
      following: false,
      isQuizCase: false,
    },
  },

  getters: {
    getFiltersObject(state) {
      return state.filters;
    },
    getFilterValue: (state) => (key) => {
      return state.filters[key];
    },
  },

  mutations: {
    setSectionsCaseFilter(state, sections) {
      state.filters.sections = sections;
    },
    setTagsCaseFilter(state, tags) {
      state.filters = { ...state.filters, tags: tags };
    },
    setGroupCaseFilter(state, group) {
      Vue.set(state.filters, 'group', group);
    },
    setOrderByCaseFilter(state, orderBy) {
      if (orderBy !== undefined) {
        state.filters.orderBy = orderBy;
      }
    },
    setFollowingCaseFilter(state, following) {
      state.filters.following = following;
    },
    setIsQuizCaseFilter(state, isQuizCase) {
      state.filters.isQuizCase = isQuizCase;
    },
  },
  actions: {
    casesFiltersChangeGroupId({ commit }, groupId) {
      commit('setGroupCaseFilter', groupId);
    },

    casesFiltersChangeIsQuizCase({ commit }, isQuizCase) {
      commit('setIsQuizCaseFilter', isQuizCase);
    },

    setFilters({ commit }, { key, value }) {
      switch (key) {
        case 'sections':
          commit('setSectionsCaseFilter', value);
          break;
        case 'tags':
          commit('setTagsCaseFilter', value);
          break;
        case 'group':
          commit('setGroupCaseFilter', value);
          break;
        case 'orderBy':
          commit('setOrderByCaseFilter', value);
          break;
        case 'following':
          commit('setFollowingCaseFilter', value);
          break;
        default:
          break;
      }
    },

    setStateFiltersFromObject({ commit }, filters) {
      if (filters.sections) {
        commit('setSectionsCaseFilter', filters.sections);
      }
      if (filters.tags) {
        commit('setTagsCaseFilter', filters.tags);
      }
      if (filters.group) {
        commit('setGroupCaseFilter', filters.group);
      }
      if (filters.orderBy) {
        commit('setOrderByCaseFilter', filters.orderBy);
      }
      if (filters.following) {
        commit('setFollowingCaseFilter', filters.following);
      }
    },

    setUrlQueryFromStateObject({ state }, routeName) {
      //let page = getters.getPaginationData.current_page;
      //let objectParams = { page: page, ...state };
      let objectParams = { ...state };
      let params = Object.fromEntries(Object.entries(objectParams));
      let route = this._vm.$route(routeName, params).url();
      if (window && window.history) {
        window.history.pushState(null, document.title, route);
      }
    },

    setFiltersFromQueryString({ commit }) {
      if (window && window.location && window.location.search) {
        const parsed = queryString.parse(window.location.search);
        const mapped = mapKeys(parsed, (value, key) => {
          return key.replace('filters[', '').replace(']', '');
        });

        let { group, following, orderBy } = mapped;

        let sections = [];
        let tags = [];

        for (var key in mapped) {
          if (key.indexOf('section') > -1) {
            sections.push(mapped[key]);
          }
          if (key.indexOf('tags') > -1) {
            tags.push(mapped[key]);
          }
        }

        commit('setSectionsCaseFilter', sections);
        commit('setTagsCaseFilter', tags);
        commit('setGroupCaseFilter', group);
        commit('setOrderByCaseFilter', orderBy);
        commit('setFollowingCaseFilter', following);
      }
    },

    async saveFilters({ state }, { route, toast_msg }) {
      const response = await this._vm.$api('users.case_filters.store', {
        version: '1.0',
        name: 'default',
        filters: { ...state.filters },
        scope: route,
      });
      if (response?.status === 200 && toast_msg) {
        toastr.success('Filters saved!');
      }
    },

    clearFilters({ commit }) {
      commit('setSectionsCaseFilter', []);
      commit('setTagsCaseFilter', []);
      commit('setGroupCaseFilter', '0');
      commit('setOrderByCaseFilter', 'last_activity_at');
      commit('setFollowingCaseFilter', false);
    },
  },
};
